// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3ogMr","containerItemsCenter":"Skeleton_containerItemsCenter__3z7Lr"};